import { Injectable } from '@angular/core';
import { DynamicField } from '@cargos/sprintpay-models';

@Injectable({
    providedIn: 'root',
})
export class FacilityConfigurationService {
    private facility_config: DynamicField[] = [];

    setFacilityConfiguration(facility_config: DynamicField[]): void {
        this.facility_config = facility_config;
    }

    getFacilityConfiguration(): DynamicField[] {
        return this.facility_config;
    }
}
